import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateMealCategoryTierEntity } from '../../domain/entities/UpdateMealCategoryTierEntity'

export class UpdateMealCategoryTierModel extends UpdateMealCategoryTierEntity {
  constructor(dataDto: UpdateMealCategoryTierEntity) {
    super()
    mapEntityProperties<UpdateMealCategoryTierModel>(this, dataDto)
  }
}
